import { UseQueryResult, useQueries } from "@tanstack/react-query";
import { chunk } from "lodash";

import { getCarbonProgramOutcomesAdmin } from "services";

import { combineQueries } from "utils";

import { GET_CARBON_PROGRAM_OUTCOMES_ADMIN, PROGRAM_OUTCOME_CHUNK_SIZE } from "consts";

import { CarbonProgramOutcomesResponse } from "models";

type UseGetCarbonProgramOutcomesReturnType = Pick<UseQueryResult<CarbonProgramOutcomesResponse>, "data" | "isFetching" | "isLoading"> & {
  progress: number;
};

export const useGetAllCarbonProgramOutcomesAdmin = (
  fieldIds: string[],
  isVerification?: boolean,
  enabled: boolean = true
): UseGetCarbonProgramOutcomesReturnType => {
  const chunks = chunk(fieldIds, PROGRAM_OUTCOME_CHUNK_SIZE);

  const queries = chunks.map((chunk) => ({
    queryKey: [GET_CARBON_PROGRAM_OUTCOMES_ADMIN, chunk, isVerification],
    queryFn: () => getCarbonProgramOutcomesAdmin({ fieldIds: chunk, isVerification }),
    staleTime: 1000 * 60 * 60 * 24, // 1 day
    enabled,
  }));

  return useQueries({
    queries,
    combine: combineQueries(true, chunks.length),
  });
};
